import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEsPe from '@angular/common/locales/es-PE';
import { ADMIN_APP_CONFIG, APP_CONFIG } from '@ribera-web/app-token';
import { environment } from '../environments/environment';
import { HttpLoadingInterceptor } from '@ribera-web/http-loading';
import { authInterceptor } from '@ribera-web/auth-data-acess';
import { DialogService } from 'primeng/dynamicdialog';

registerLocaleData(localeEsPe, 'es-PE');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({ 
        paramsInheritanceStrategy: 'always'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'es-PE' },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.my-app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    provideHttpClient(withInterceptors([HttpLoadingInterceptor, authInterceptor])),
    {
      provide: APP_CONFIG,
      useValue: environment,
    },
    {
      provide: ADMIN_APP_CONFIG,
      useValue: environment,
    },
    DialogService,
  ],
};
